// Sons ludiques synthétisés (Web Audio) pour les présentations RVP — aucun asset externe
let ctx = null;

const getCtx = () => {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
};

export const unlockAudio = () => { getCtx(); };

const MUTE_KEY = 'rvp_sounds_muted';
export const isSoundMuted = () => {
  try { return localStorage.getItem(MUTE_KEY) === '1'; } catch { return false; }
};
export const setSoundMuted = (m) => {
  try { localStorage.setItem(MUTE_KEY, m ? '1' : '0'); } catch { /* noop */ }
};

function tone(c, { freq = 440, endFreq = null, type = 'sine', dur = 0.15, vol = 0.18, when = 0 }) {
  const osc = c.createOscillator();
  const gain = c.createGain();
  const t0 = c.currentTime + when;
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  if (endFreq) osc.frequency.exponentialRampToValueAtTime(endFreq, t0 + dur);
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(vol, t0 + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.05);
}

const SOUNDS = {
  // Transition de slide — "whoosh" montant et joueur
  whoosh: (c) => {
    tone(c, { freq: 280, endFreq: 950, type: 'sine', dur: 0.28, vol: 0.14 });
    tone(c, { freq: 560, endFreq: 1400, type: 'triangle', dur: 0.22, vol: 0.07, when: 0.04 });
  },
  // Arrivée sur un QCM — "ding-dong" interrogatif
  question: (c) => {
    tone(c, { freq: 880, type: 'triangle', dur: 0.16, vol: 0.16 });
    tone(c, { freq: 660, type: 'triangle', dur: 0.24, vol: 0.16, when: 0.16 });
  },
  // Chiffre choc / message SR — impact grave dramatique
  impact: (c) => {
    tone(c, { freq: 150, endFreq: 48, type: 'sine', dur: 0.5, vol: 0.4 });
    tone(c, { freq: 300, endFreq: 90, type: 'square', dur: 0.18, vol: 0.06 });
  },
  // Bonne réponse révélée — arpège victorieux
  success: (c) => {
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => {
      tone(c, { freq: f, type: 'triangle', dur: 0.22, vol: 0.15, when: i * 0.09 });
    });
  },
  // Engagement / CTA final — petit "tada" festif
  tada: (c) => {
    tone(c, { freq: 392, type: 'triangle', dur: 0.14, vol: 0.14 });
    tone(c, { freq: 523.25, type: 'triangle', dur: 0.14, vol: 0.14, when: 0.12 });
    tone(c, { freq: 783.99, type: 'triangle', dur: 0.4, vol: 0.17, when: 0.24 });
  },
  // Petit "pop" générique
  pop: (c) => {
    tone(c, { freq: 600, endFreq: 900, type: 'square', dur: 0.08, vol: 0.1 });
  },
};

export const playRvpSound = (name) => {
  if (isSoundMuted()) return;
  try {
    const c = getCtx();
    if (!c) return;
    (SOUNDS[name] || SOUNDS.whoosh)(c);
  } catch { /* noop */ }
};
